import {isNotEmpty} from 'ramda';

import {PurchasePriceRuleScope} from '@dms/api/sales';

import {PURCHASE_PRICE_RULE_NAME_MAX_LENGTH} from '../constants/PURCHASE_PRICE_RULE_NAME_MAX_LENGTH';

const LABEL_SEPARATOR = ', ';
const PART_SEPARATOR = ' ';

interface BuildPurchasePriceRuleNameParams {
  scope: PurchasePriceRuleScope;
  getLabel: (key: string) => string;
}

/**
 * Suggests a rule name from its scope, e.g. "BMW X5 M Sport" or "Audi, Škoda". Model families and
 * trims only exist with a single make, so they follow the make.
 */
export const buildPurchasePriceRuleName = (params: BuildPurchasePriceRuleNameParams) => {
  const joinLabels = (keys: string[]) => keys.map(params.getLabel).join(LABEL_SEPARATOR);

  return [
    joinLabels(params.scope.makes),
    joinLabels(params.scope.modelFamilies),
    joinLabels(params.scope.trims),
  ]
    .filter(isNotEmpty)
    .join(PART_SEPARATOR)
    .slice(0, PURCHASE_PRICE_RULE_NAME_MAX_LENGTH);
};
